import { useDispatch, useSelector } from 'react-redux';

import Model from '@tripian/model';
import { api } from '@tripian/core';
import { useCallback } from 'react';
import ICombinedState from '../redux/model/ICombinedState';
import { loginFinally, logoutFinally } from '../redux/action/user';
import { clear } from '../redux/action/trip';

const useAuth = () => {
  const isLoggedIn = useSelector((state: ICombinedState) => state.user.isLoggedIn);
  const dispatch = useDispatch();

  const registerEmail = useCallback(
    (registerRequest: Model.RegisterRequestEmail): Promise<Model.User> => api.registerEmail(registerRequest.email, registerRequest.password, registerRequest.first_name || '', registerRequest.last_name || '', registerRequest.profile),
    [],
  );

  const loggedIn = useCallback((): void => {
    dispatch(loginFinally());
  }, [dispatch]);

  const logout = useCallback((): void => {
    api.logout();
    dispatch(logoutFinally());
    dispatch(clear());
  }, [dispatch]);

  return { isLoggedIn, registerEmail, loggedIn, logout };
};

export default useAuth;
